import { useRef, useState, useEffect } from 'react';

import useIsMobile from '@/hooks/useIsMobile';

const scrollThreshold = 250;
const minWidth = 95;
const maxWidth = 100;

const useResizeLayout = () => {
  const headerRef = useRef<HTMLDivElement>(null);
  const mainRef = useRef<HTMLElement>(null);

  const [introHeight, setIntroHeight] = useState<number>(0);
  const [mainWidth, setMainWidth] = useState<string>(`${minWidth}%`);
  const isMobile = useIsMobile();

  useEffect(() => {
    if (headerRef.current) {
      const { height } = headerRef.current.getBoundingClientRect();

      setIntroHeight(height);
    }
  }, []);

  useEffect(() => {
    if (isMobile) {
      setMainWidth('100%');

      return;
    }

    const handleScroll = () => {
      if (mainRef.current && introHeight) {
        const { top } = mainRef.current.getBoundingClientRect();
        const offset = Math.max(0, Math.min(introHeight - top, scrollThreshold));

        const widthPercentage = minWidth + (offset / scrollThreshold) * (maxWidth - minWidth);

        const roundedWidth = Math.round(widthPercentage * 10) / 10;

        setMainWidth(`${roundedWidth}%`);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [introHeight, isMobile]);

  return {
    headerRef,
    mainRef,
    introHeight,
    mainWidth,
  };
};

export default useResizeLayout;
